<template>
  <div></div>
</template>

<script>
import { GateReportTypeRoute } from "@evercam/shared/types/components"

export default {
  asyncData({ redirect }) {
    return redirect(`/gate-report/${GateReportTypeRoute.GateReportProjects}`)
  },
}
</script>
